import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

const MediaRecordingCursor = () => {
	const frame = useCurrentFrame();

	return (
		<MacOSCursor
			cursor={interpolate(frame, [1, 461, 477], ['auto', 'pointer', 'auto'], {
				easing: Easing.step1,
				extrapolateLeft: 'clamp',
				extrapolateRight: 'clamp',
			})}
			style={{
				position: 'absolute',
				left: 0,
				top: 0,
				scale: interpolate(
					frame,
					[0, 497, 503],
					[3.2798320224919038, 2.9518488202427133, 3.2798320224919038],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
				translate: interpolate(
					frame,
					[
						1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 27,
						28, 29, 30, 31, 32, 33, 34, 35, 37, 38, 39, 40, 47, 48, 49, 50, 51,
						52, 53, 54, 55, 56, 57, 63, 64, 65, 66, 67, 68, 69, 92, 93, 94, 95,
						96, 97, 98, 99, 100, 101, 102, 103, 110, 111, 112, 117, 118, 119,
						120, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175,
						176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188,
						189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201,
						202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 218, 219, 220,
						221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233,
						234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246,
						247, 248, 249, 250, 251, 252, 253, 254, 255, 256, 257, 258, 259,
						260, 261, 262, 263, 272, 273, 274, 275, 276, 277, 278, 279, 280,
						281, 282, 283, 284, 285, 286, 287, 288, 289, 290, 291, 292, 293,
						294, 295, 296, 297, 298, 299, 300, 301, 302, 303, 304, 305, 306,
						307, 308, 309, 310, 311, 312, 313, 314, 315, 316, 317, 318, 319,
						320, 321, 322, 323, 324, 332, 333, 334, 335, 336, 337, 338, 339,
						340, 341, 342, 343, 344, 345, 346, 347, 348, 349, 350, 351, 352,
						353, 354, 355, 356, 357, 358, 359, 360, 361, 362, 363, 364, 365,
						366, 367, 368, 369, 370, 371, 372, 373, 374, 375, 376, 377, 378,
						379, 380, 381, 382, 383, 384, 385, 386, 387, 390, 391, 392, 393,
						394, 395, 396, 397, 398, 399, 400, 401, 402, 403, 404, 405, 406,
						407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417, 418, 419,
						420, 421, 422, 423, 424, 425, 426, 427, 428, 429, 430, 431, 432,
						433, 434, 435, 436, 437, 438, 439, 440, 441, 442, 443, 444, 445,
						446, 447, 448, 449, 450, 451, 452, 453, 459, 460, 461, 462, 463,
						464, 465, 466, 467, 468, 469, 470, 471, 472, 473, 474, 475, 476,
						477, 478, 479, 487, 488, 489, 490, 491, 492,
					],
					[
						'880.5067796006975px 2763.4890921385104px',
						'908.449411011068px 2723.8876828356883px',
						'983.142460585786px 2621.2007544752482px',
						'1076.105199473291px 2475.312288693548px',
						'1119.6142211466602px 2295.933663119684px',
						'1178.484643581622px 2010.729207445105px',
						'1265.9511014626855px 1782.114666002349px',
						'1354.8781095412648px 1558.0227054343572px',
						'1443.4848215238976px 1359.951599701057px',
						'1507.7490302145984px 1229.924196590626px',
						'1551.6680308907792px 1142.7267874301576px',
						'1572.8972561301114px 1102.715399124524px',
						'1604.017224812271px 1061.9865475639704px',
						'1643.6955051781204px 1020.2327484963878px',
						'1660.1331008220934px 1005.9859781486886px',
						'1666.6030819602122px 1000.1437773586249px',
						'1669.3832520730275px 997.8888928431617px',
						'1671.151286522652px 996.6461439908894px',
						'1671.151286522652px 996.6461439908894px',
						'1627.0529200327414px 997.863269155486px',
						'1582.1474073810457px 1000.9893590519235px',
						'1539.227730524218px 1000.861240613545px',
						'1539.227730524218px 1000.861240613545px',
						'1509.1967685682764px 999.0932061639205px',
						'1487.45506957543px 997.2739243389445px',
						'1463.8300295384179px 995.9158688921315px',
						'1459.2433894444644px 995.7108793907257px',
						'1459.2433894444644px 995.7108793907257px',
						'1459.26901313214px 995.7108793907257px',
						'1460.0377237624116px 995.7108793907257px',
						'1460.358019858358px 995.7108793907257px',
						'1460.358019858358px 995.7108793907257px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1458.1671945620842px 994.7628029467242px',
						'1465.7774298017723px 996.3386597387807px',
						'1481.0491476565003px 998.6319797857575px',
						'1508.9405316915193px 1001.2071603971672px',
						'1557.0233816150042px 1003.8079646962526px',
						'1631.6651838143707px 1008.0614968504218px',
						'1702.5403039254068px 1014.2496174241077px',
						'1821.434214740738px 1034.0695398412756px',
						'1940.6227979643404px 1058.4889141962349px',
						'1993.638207765401px 1069.0330616747926px',
						'2026.2955977081035px 1075.1314993416136px',
						'2029.2295099469734px 1075.6824086266415px',
						'2029.2295099469734px 1075.6824086266415px',
						'2029.2295099469734px 1075.7977152211822px',
						'2029.2295099469734px 1076.1436350048045px',
						'2029.2295099469734px 1076.1436350048045px',
						'2030.6644364568135px 1077.5785615146447px',
						'2031.4587707747608px 1078.1038471119969px',
						'2031.5997010569772px 1078.2191537065376px',
						'2031.5997010569772px 1078.2191537065376px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'2028.8579664756753px 1076.7586035090217px',
						'1982.9403181607888px 1148.9149080038435px',
						'1848.4672052386206px 1345.7048293533578px',
						'1727.1134204064201px 1604.8115591302183px',
						'1569.6814833268088px 2024.630058009182px',
						'1317.1344175949323px 2667.477134417595px',
						'2835.6966440086835px 3080.7359692515747px',
						'2734.0218513114346px 3156.1721057688887px',
						'2734.0218513114346px 3156.1721057688887px',
						'2711.0630271539912px 3156.1721057688887px',
						'2711.0630271539912px 3156.1721057688887px',
						'2711.0630271539912px 3156.1721057688887px',
						'2707.7831951314993px 3139.7729456564293px',
						'2707.7831951314993px 3139.7729456564293px',
						'1001.399338054735px 2880.7558987864336px',
						'987.2806861454145px 2849.8921669810316px',
						'984.7183173778427px 2848.7903484109756px',
						'984.0521014982739px 2848.7006655041105px',
						'982.591551300758px 2848.5212996903806px',
						'981.6947222321079px 2848.3547457204886px',
						'976.4418662585857px 2848.1241325314068px',
						'965.3211858073241px 2849.9049788248694px',
						'953.1755578490338px 2852.992633189793px',
						'944.4891277269654px 2855.0681518915267px',
						'941.8370760525286px 2855.555001957365px',
						'939.8256165699847px 2855.9649809601765px',
						'938.6469269369017px 2855.9649809601765px',
						'938.531620342361px 2855.747179614933px',
						'938.0063347450088px 2851.083668457952px',
						'936.9045161749528px 2837.8746574611196px',
						'934.6624435033276px 2803.295490942738px',
						'931.2673048862949px 2775.2631766255026px',
						'927.5134346418023px 2761.8619879711023px',
						'925.2073027509877px 2758.1081177266096px',
						'925.2073027509877px 2758.1081177266096px',
						'919.3907256485996px 2758.6846506993134px',
						'907.9497491013915px 2760.785793088722px',
						'902.735328659383px 2762.182284067049px',
						'898.7764689134845px 2763.0406776041855px',
						'896.3422185842913px 2763.7581408591054px',
					],
					{
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				),
			}}
		/>
	);
};

export const ExploreMediaRecording20261028Composition = () => {
	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={529}
			style={{
				width: 2510,
				height: 1440,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/media-source-2026-10-28-9e83a1a61ff8.mp4'
				}
				durationInFrames={529}
				style={{
					position: 'absolute',
				}}
			/>
			<MediaRecordingCursor />
		</AbsoluteFill>
	);
};
